<script setup lang="ts">
import { computed } from 'vue'

interface TProps {
  isMobile?: boolean
  fallbackText?: string
  to?: string
  rel?: string
  addCss?: string
  overrideCssClass?: string
}

const props = withDefaults(defineProps<TProps>(), {
  isMobile: false,
  fallbackText: 'Link',
  to: '/',
  rel: '',
  addCss: '',
  overrideCssClass: '',
})

const emits = defineEmits<{
  (e: 'clicked'): any
}>()

const cssClass = computed((): string => {
  if ((props.overrideCssClass || '').trim().length > 0) {
    return (props.overrideCssClass || '').trim()
  }

  let results: string[] = []
  if (props.addCss.trim().length > 0) {
    results.push(props.addCss.trim())
  }
  results.push(
    'rounded-md py-2 px-3 text-sm font-medium leading-5',
    'bg-none hover:bg-primary hover:content-primary',
    'focus:outline-none transition duration-150 ease-in-out',
  )

  if (!!props.isMobile) {
    results.push(`block text-base`)
  }

  return results.join(' ').trim()
})

const onClick = () => {
  emits('clicked')
}
</script>

<template>
  <ClientOnly fallback-tag="span" :fallback="fallbackText">
    <a :href="to" :rel="rel" :class="cssClass" aria-current="page" @click="onClick">
      <slot></slot>
    </a>
  </ClientOnly>
</template>
